import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../i18n/LanguageContext";
import INFO from "../../data/user";

import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;
	const { locale, setLocale, t } = useLanguage();
	const location = useLocation();
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		setMenuOpen(false);
	}, [location.pathname]);

	useEffect(() => {
		if (!menuOpen) return;
		const prev = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		const onKey = (e) => e.key === "Escape" && setMenuOpen(false);
		window.addEventListener("keydown", onKey);
		return () => {
			document.body.style.overflow = prev;
			window.removeEventListener("keydown", onKey);
		};
	}, [menuOpen]);

	const closeMenu = () => setMenuOpen(false);

	const links = [
		{ key: "home", path: "/", labelKey: "nav.home" },
		{ key: "about", path: "/about", labelKey: "nav.about" },
		{ key: "projects", path: "/projects", labelKey: "nav.projects" },
		{ key: "skills", path: "/skills", labelKey: "nav.skills" },
		{ key: "articles", path: "/articles", labelKey: "nav.articles" },
		{ key: "contact", path: "/contact", labelKey: "nav.contact" },
	];

	const brandName = INFO.main.name.replace(/\.$/, "");
	const resumeHref = `/resume/Qodirxon-Nodirxonov-${locale}.pdf`;

	return (
		<div className="nav-container">
			<header
				className={`site-header ${menuOpen ? "site-header--open" : ""}`}
			>
				<div className="site-header__bar">
					<Link to="/" className="site-header__brand" onClick={closeMenu}>
						<span className="site-header__mark" aria-hidden="true">
							{brandName.charAt(0)}
						</span>
						<span className="site-header__name">{brandName}</span>
					</Link>

					<nav className="site-header__nav" aria-label="Main">
						<ul className="site-header__list">
							{links.map(({ key, path, labelKey }) => (
								<li
									key={key}
									className={
										active === key
											? "site-header__item is-active"
											: "site-header__item"
									}
								>
									<Link to={path}>{t(labelKey)}</Link>
								</li>
							))}
						</ul>
					</nav>

					<div className="site-header__actions">
						<a
							className="resume-btn"
							href={resumeHref}
							download
							title={t("nav.resumeTitle")}
						>
							<FontAwesomeIcon icon={faDownload} />
							<span className="resume-btn__label">{t("nav.resume")}</span>
						</a>

						<div className="lang-switcher" aria-label="Language">
							{["uz", "en", "ru"].map((code) => (
								<button
									key={code}
									type="button"
									className={
										locale === code
											? "lang-btn lang-btn--on"
											: "lang-btn"
									}
									onClick={() => setLocale(code)}
								>
									{t(`lang.${code}`)}
								</button>
							))}
						</div>

						<button
							type="button"
							className="site-header__burger"
							aria-expanded={menuOpen}
							aria-controls="mobile-menu"
							aria-label={menuOpen ? "Close menu" : "Open menu"}
							onClick={() => setMenuOpen((o) => !o)}
						>
							<span />
							<span />
							<span />
						</button>
					</div>
				</div>
			</header>

			<div
				className={`mobile-menu ${menuOpen ? "is-open" : ""}`}
				id="mobile-menu"
				aria-hidden={!menuOpen}
			>
				<nav aria-label="Mobile">
					<ul className="mobile-menu__list">
						{links.map(({ key, path, labelKey }, i) => (
							<li
								key={key}
								className={
									active === key
										? "mobile-menu__item is-active"
										: "mobile-menu__item"
								}
								style={{ "--i": i }}
							>
								<Link
									to={path}
									onClick={closeMenu}
									tabIndex={menuOpen ? 0 : -1}
								>
									<span className="mobile-menu__num">
										{String(i + 1).padStart(2, "0")}
									</span>
									<span className="mobile-menu__label">
										{t(labelKey)}
									</span>
									<span
										className="mobile-menu__arrow"
										aria-hidden="true"
									>
										→
									</span>
								</Link>
							</li>
						))}
					</ul>
				</nav>

				<a
					className="mobile-menu__resume"
					href={resumeHref}
					download
					tabIndex={menuOpen ? 0 : -1}
				>
					<FontAwesomeIcon icon={faDownload} /> {t("nav.resumeTitle")}
				</a>

				<a
					className="mobile-menu__mail"
					href={`mailto:${INFO.main.email}`}
					tabIndex={menuOpen ? 0 : -1}
				>
					{INFO.main.email}
				</a>
			</div>
		</div>
	);
};

export default NavBar;
